import axios from "axios";

const putDoctorForgot = async (baseUrl, token, tckno) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + `/doctor/password/forgot?tckno=` + tckno, {}, config)
        .then((res) => {
            putResponse = {
                status: res.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    result:  error.response.status
                }
            }
        });
    return putResponse
}

export default putDoctorForgot;